import desktopBackgroundLandingFirst from 'src/assets/images/landing/desktopBackgroundLandingFirst.webp';
import desktopBackgroundLandingSecond from 'src/assets/images/landing/desktopBackgroundLandingSecond.webp';
import desktopBackgroundLandingThird from 'src/assets/images/landing/desktopBackgroundLandingThird.webp';
import desktopBackgroundLandingFourth from 'src/assets/images/landing/desktopBackgroundLandingFourth.webp';
import landingPromoName from 'src/assets/images/landing/landingPromoName.webp';
import landingPromoNameSecond from 'src/assets/images/landing/landingPromoNameSecond.webp';
import landingPromoNameThird from 'src/assets/images/landing/landingPromoNameThird.webp';
import landingPromoNameFourth from 'src/assets/images/landing/landingPromoNameFourth.webp';
import landingImage from 'src/assets/images/landing/landingImage.webp';
import landingImageSecond from 'src/assets/images/landing/landingImageSecond.webp';
import landingImageThird from 'src/assets/images/landing/landingImageThird.webp';
import padBackgroundLandingFirst from 'src/assets/images/landing/padBackgroundLandingFirst.webp';
import landingImageFourth from 'src/assets/images/landing/landingImageFourth.webp';
import padBackgroundLandingSecond from 'src/assets/images/landing/padBackgroundLandingSecond.webp';
import padBackgroundLandingThird from 'src/assets/images/landing/padBackgroundLandingThird.webp';
import padBackgroundLandingFourth from 'src/assets/images/landing/padBackgroundLandingFourth.webp';
import { isProductionEnv } from 'src/api';
import { Cash, Chat, Cherry, Timer } from './icons';

export const WELCOME_BONUS_ID = isProductionEnv ? 431 : 273;
export const WELCOME_BONUS_VIP_ID = isProductionEnv ? 433 : 274;
export const NUMBER_OF_IMAGES = 4;

export const descriptions = [
  {
    icon: <Timer className="360:w-[30px] 360:h-[30px] h-6 w-6" />,
    value: 'landing.benefitMinTitle',
    nameDescription: 'landing.benefitMinText'
  },
  {
    icon: <Chat className="360:w-[30px] 360:h-[30px] h-6 w-6" />,
    value: '24/7',
    nameDescription: 'landing.benefitLiveChat'
  },
  {
    icon: <Cherry className="360:w-[30px] 360:h-[30px] h-6 w-6" />,
    value: '5000+',
    nameDescription: 'landing.benefitGames'
  },
  {
    icon: <Cash className="360:w-[30px] 360:h-[30px] h-6 w-6" />,
    value: 'landing.benefitNoFeesTitle',
    nameDescription: 'landing.benefitNoFeesText'
  }
];

export const landingImages = [
  {
    desktopImageBackground: desktopBackgroundLandingFirst,
    landingPromoName: landingPromoName,
    mobileImage: landingImage,
    landingPad: padBackgroundLandingFirst
  },
  {
    desktopImageBackground: desktopBackgroundLandingSecond,
    landingPromoName: landingPromoNameSecond,
    mobileImage: landingImageSecond,
    landingPad: padBackgroundLandingSecond
  },
  {
    desktopImageBackground: desktopBackgroundLandingThird,
    landingPromoName: landingPromoNameThird,
    mobileImage: landingImageThird,
    landingPad: padBackgroundLandingThird
  },
  {
    desktopImageBackground: desktopBackgroundLandingFourth,
    landingPromoName: landingPromoNameFourth,
    mobileImage: landingImageFourth,
    landingPad: padBackgroundLandingFourth
  }
];
